"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
var ColoredDatePickerIcon_1 = require("./ColoredDatePickerIcon");
__createBinding(exports, ColoredDatePickerIcon_1, "ColoredDatePickerIcon");
var ColoredErrorIcon_1 = require("./ColoredErrorIcon");
__createBinding(exports, ColoredErrorIcon_1, "ColoredErrorIcon");
var ColoredInfoIcon_1 = require("./ColoredInfoIcon");
__createBinding(exports, ColoredInfoIcon_1, "ColoredInfoIcon");
var ColoredMailIcon_1 = require("./ColoredMailIcon");
__createBinding(exports, ColoredMailIcon_1, "ColoredMailIcon");
var ColoredPlayIcon_1 = require("./ColoredPlayIcon");
__createBinding(exports, ColoredPlayIcon_1, "ColoredPlayIcon");
var ColoredProfileIcon_1 = require("./ColoredProfileIcon");
__createBinding(exports, ColoredProfileIcon_1, "ColoredProfileIcon");
var ColoredSuccessIcon_1 = require("./ColoredSuccessIcon");
__createBinding(exports, ColoredSuccessIcon_1, "ColoredSuccessIcon");
var ColoredVideoIcon_1 = require("./ColoredVideoIcon");
__createBinding(exports, ColoredVideoIcon_1, "ColoredVideoIcon");
var ColoredWarningIcon_1 = require("./ColoredWarningIcon");
__createBinding(exports, ColoredWarningIcon_1, "ColoredWarningIcon");
var ColoredWorkgroupIcon_1 = require("./ColoredWorkgroupIcon");
__createBinding(exports, ColoredWorkgroupIcon_1, "ColoredWorkgroupIcon");
var ColoredChartWidgetIcon_1 = require("./ColoredChartWidgetIcon");
__createBinding(exports, ColoredChartWidgetIcon_1, "ColoredChartWidgetIcon");
var ColoredImageWidgetIcon_1 = require("./ColoredImageWidgetIcon");
__createBinding(exports, ColoredImageWidgetIcon_1, "ColoredImageWidgetIcon");
var ColoredMetricWidgetIcon_1 = require("./ColoredMetricWidgetIcon");
__createBinding(exports, ColoredMetricWidgetIcon_1, "ColoredMetricWidgetIcon");
var ColoredReportWidgetIcon_1 = require("./ColoredReportWidgetIcon");
__createBinding(exports, ColoredReportWidgetIcon_1, "ColoredReportWidgetIcon");
var ColoredRichTextWidgetIcon_1 = require("./ColoredRichTextWidgetIcon");
__createBinding(exports, ColoredRichTextWidgetIcon_1, "ColoredRichTextWidgetIcon");
var ColoredShortcutWidgetIcon_1 = require("./ColoredShortcutWidgetIcon");
__createBinding(exports, ColoredShortcutWidgetIcon_1, "ColoredShortcutWidgetIcon");
var ColoredTitleWidgetIcon_1 = require("./ColoredTitleWidgetIcon");
__createBinding(exports, ColoredTitleWidgetIcon_1, "ColoredTitleWidgetIcon");
var ColoredWebContentWidgetIcon_1 = require("./ColoredWebContentWidgetIcon");
__createBinding(exports, ColoredWebContentWidgetIcon_1, "ColoredWebContentWidgetIcon");
var ColoredWorkInsightsWidgetIcon_1 = require("./ColoredWorkInsightsWidgetIcon");
__createBinding(exports, ColoredWorkInsightsWidgetIcon_1, "ColoredWorkInsightsWidgetIcon");
//# sourceMappingURL=index.js.map